import * as React from 'react';
import {
  MasonryEngineNode,
  MasonryEngineNodeRendererProps,
} from '@leagueplatform/masonry-engine';
import { useInvokeAction } from '@leagueplatform/masonry';

import { FormField, Select } from '@leagueplatform/genesis-core';
import { MasonryReloadAction } from '@leagueplatform/masonry-renderers';

export const NODE_TYPE_MEMBER_DROPDOWN = 'memberDropdown';

type Option = {
  value: string;
  label: string;
};

type MemberDropdownProps = {
  label: string;
  options: Option[];
  value?: string;
};

type MemberDropdownNode = MasonryEngineNode<
  typeof NODE_TYPE_MEMBER_DROPDOWN,
  MemberDropdownProps,
  { onSelect?: MasonryReloadAction },
  {}
>;

export type MemberDropdownRendererProps =
  MasonryEngineNodeRendererProps<MemberDropdownNode>;

export function MemberDropdownRenderer({
  label,
  options,
  value: defaultValue,
  onSelect,
}: MemberDropdownRendererProps) {
  const invokeAction = useInvokeAction();
  const [value, setValue] = React.useState<string | undefined>(defaultValue);

  const handleChange = React.useCallback(
    (event: React.ChangeEvent<HTMLSelectElement>) => {
      setValue(event.target.value);
      if (onSelect) {
        invokeAction({
          event,
          ...onSelect,
          payload: {
            ...onSelect.payload,
            extraQueryParams: [
              ...(onSelect.payload?.extraQueryParams || []),
              {
                key: 'userId',
                value: event.target.value,
              },
            ],
          },
        });
      }
    },
    [invokeAction, onSelect],
  );

  const id = React.useMemo(
    () => `member-dropdown-${label.toLowerCase().replace(/\s+/g, '-')}`,
    [label],
  );

  return (
    <FormField label={label} id={id}>
      <Select id={id} options={options} value={value} onChange={handleChange} />
    </FormField>
  );
}
